import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.map";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    @import url('", "", "&display=swap');\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css, createGlobalStyle } from "styled-components";

function createGoogleFonts(fonts) {
  var base = "//fonts.googleapis.com/css?family=";
  var fontDefinitions = [];
  fonts.map(function (_ref) {
    var title = _ref.title,
        weights = _ref.config.weights;
    return fontDefinitions.push("".concat(title.replace(" ", "+")).concat(weights.length > 0 ? ":".concat(weights.join(",")) : ''));
  });
  return css(_templateObject(), base, fontDefinitions.join("|"));
}

function createStaticFonts(fonts) {
  var base = "/fonts/";
  var fontDefinitions = [];
  fonts.map(function (_ref2) {
    var filename = _ref2.filename,
        title = _ref2.title,
        weights = _ref2.config.weights;
    return weights.map(function (weight) {
      return fontDefinitions.push("\n      @font-face {\n        font-family: '".concat(title, " ").concat(weight, "';\n        src: url('").concat(base).concat(filename, "-").concat(weight, "-webfont.woff2') format('woff2'),\n            url('").concat(base).concat(filename, "-").concat(weight, "-webfont.woff') format('woff');\n        font-weight: normal;\n        font-style: normal;\n      }\n    "));
    });
  });
  return css(_templateObject2(), fontDefinitions.join(''));
}

function createFontFamilies(fontSources) {
  return fontSources.map(function (src) {
    if (src.source === "google") return createGoogleFonts(src.fonts);
    if (src.source === "static") return createStaticFonts(src.fonts);
    return "";
  });
}

var FontFamilies = createGlobalStyle(_templateObject3(), function (props) {
  return createFontFamilies(props.theme.fonts);
});
export default FontFamilies;